import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const headers = { 'Content-Type': 'application/json' };
const base = `${API_BASE_URL}/Purchase`;

const handle = (err) => {
    if (err.response?.data) throw err.response.data;
    throw err;
};

// GET cost centers the current role can issue capital stock from
export const getCapitalissueccs = async (UID, RID) => {
    try {
        const res = await axios.get(`${base}/GetCapitalissueccs`, {
            params: { UID, RID },
            headers,
        });
        return res.data;
    } catch (err) { handle(err); }
};

// GET master item codes available for conversion under a cost center
export const getCapitalItemCodes = async (UID, RID, CCCode) => {
    try {
        const res = await axios.get(`${base}/GetCapitalItemCodes`, {
            params: { UID, RID, CCCode },
            headers,
        });
        return res.data;
    } catch (err) { handle(err); }
};

// GET the stock-conversion grid rows for a master item code at a cost center
export const getCapitalStockIssueDatatable = async (MasterItemCode, cccodeval) => {
    try {
        const res = await axios.get(`${base}/GetCapitalStockIssueDatatable`, {
            params: { MasterItemCode, cccodeval },
            headers,
        });
        return res.data;
    } catch (err) { handle(err); }
};

// POST — finalize and submit the capital stock issue (conversion) transaction
// payload: { Rid, IssueQtys, Date, Remarks, MasterItemCode, SubmitType, Basic, CostCenter,
//            RoleID, Createdby, AlertType? }
export const saveCapitalItemsIssue = async (payload) => {
    try {
        const res = await axios.post(`${base}/SaveCapitalItemsIssue`, payload, {
            headers,
            timeout: 30000,
        });
        return res.data;
    } catch (err) { handle(err); }
};
